import { FaultyActionTypes } from './constants';

const INIT_STATE = {
    addedFaultyReceived: null,
    updFaultyReceived: null,
    addedFaultyReceivedBack: null,
    updFaultyReceivedBack: null,
    addedFaultyDeclare: null,
    addedFaultySent: null,
    updFaultySent: null,
    updFaultyDeclare: null,
    loading: false,
};

type InvoiceData = {
    name: string;
};

type FaultyActionType = {
    type:
        | FaultyActionTypes.API_RESPONSE_SUCCESS
        | FaultyActionTypes.API_RESPONSE_ERROR
        | FaultyActionTypes.ADD_FAULTY_RECEIVED
        | FaultyActionTypes.UPD_FAULTY_SENT
        | FaultyActionTypes.ADD_FAULTY_DECLARE
        | FaultyActionTypes.UPD_FAULTY_RECEIVED_BACK
        | FaultyActionTypes.ADD_FAULTY_RECEIVED_BACK
        | FaultyActionTypes.UPD_FAULTY_DECLARE
        | FaultyActionTypes.ADD_FAULTY_SENT
        | FaultyActionTypes.UPD_FAULTY_RECEIVED
        | FaultyActionTypes.RESET;
    payload: {
        actionType?: string;
        data?: InvoiceData | {};
        error?: string;
    };
};

type State = {
    loading?: boolean;
    value?: boolean;
};

const Sales = (state: State = INIT_STATE, action: FaultyActionType): any => {
    switch (action.type) {
        case FaultyActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case FaultyActionTypes.ADD_FAULTY_RECEIVED: {
                    return {
                        ...state,
                        addedFaultyReceived: action.payload,
                        loading: false,
                    };
                }
                case FaultyActionTypes.UPD_FAULTY_RECEIVED_BACK: {
                    return {
                        ...state,
                        updFaultyReceivedBack: action.payload,
                        loading: false,
                    };
                }
                case FaultyActionTypes.ADD_FAULTY_RECEIVED_BACK: {
                    return {
                        ...state,
                        addedFaultyReceivedBack: action.payload,
                        loading: false,
                    };
                }
                case FaultyActionTypes.UPD_FAULTY_DECLARE: {
                    return {
                        ...state,
                        updFaultyDeclare: action.payload,
                        loading: false,
                    };
                }
                case FaultyActionTypes.ADD_FAULTY_DECLARE: {
                    return {
                        ...state,
                        addedFaultyDeclare: action.payload,
                        loading: false,
                    };
                }
                case FaultyActionTypes.ADD_FAULTY_SENT: {
                    return {
                        ...state,
                        addedFaultySent: action.payload,
                        loading: false,
                    };
                }
                case FaultyActionTypes.UPD_FAULTY_RECEIVED: {
                    return {
                        ...state,
                        updFaultyReceived: action.payload,
                        loading: false,
                    };
                }
                case FaultyActionTypes.UPD_FAULTY_SENT: {
                    return {
                        ...state,
                        updFaultySent: action.payload,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case FaultyActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case FaultyActionTypes.ADD_FAULTY_RECEIVED: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        addedFaultyReceived: null,
                        loading: false,
                    };
                }
                case FaultyActionTypes.UPD_FAULTY_RECEIVED_BACK: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        updFaultyReceivedBack: null,
                        loading: false,
                    };
                }
                case FaultyActionTypes.ADD_FAULTY_RECEIVED_BACK: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        addedFaultyReceivedBack: null,
                        loading: false,
                    };
                }
                case FaultyActionTypes.UPD_FAULTY_DECLARE: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        updFaultyDeclare: null,
                        loading: false,
                    };
                }
                case FaultyActionTypes.ADD_FAULTY_DECLARE: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        addedFaultyDeclare: null,
                        loading: false,
                    };
                }
                case FaultyActionTypes.ADD_FAULTY_SENT: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        addedFaultySent: null,
                        loading: false,
                    };
                }
                case FaultyActionTypes.UPD_FAULTY_RECEIVED: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        updFaultyReceived: null,
                        loading: false,
                    };
                }
                case FaultyActionTypes.UPD_FAULTY_SENT: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        updFaultySent: null,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case FaultyActionTypes.ADD_FAULTY_RECEIVED:
            return { ...state, loading: true, addedFaultyReceived: null };
            case FaultyActionTypes.UPD_FAULTY_RECEIVED_BACK:
                return { ...state, loading: true, updFaultyReceivedBack: null };
                case FaultyActionTypes.ADD_FAULTY_RECEIVED_BACK:
                    return { ...state, loading: true, addedFaultyReceivedBack: null };
            case FaultyActionTypes.UPD_FAULTY_DECLARE:
                return { ...state, loading: true, updFaultyDeclare: null };
            case FaultyActionTypes.ADD_FAULTY_DECLARE:
                return { ...state, loading: true, addedFaultyDeclare: null };
                case FaultyActionTypes.ADD_FAULTY_SENT:
                    return { ...state, loading: true, addedFaultySent: null };
        case FaultyActionTypes.UPD_FAULTY_RECEIVED:
            return { ...state, loading: true, updFaultyReceived: null };
            case FaultyActionTypes.UPD_FAULTY_SENT:
                return { ...state, loading: true, updFaultySent: null };
        case FaultyActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                updFaultyDeclare:null,
                addedFaultyDeclare:null,
                addedFaultySent:null,
                updFaultyReceivedBack:null,
addedFaultyReceivedBack:null,
                addedFaultyReceived: null,
                updFaultySent:null,
                updFaultyReceived: null,
            };
        default:
            return { ...state };
    }
};

export default Sales;
